export const PROFILE_PATH = '/:entityName';

// New profile-specific paths (canonical URL for personal entities)
export const PROFILE_BASE_PATH = '/profile/:entityName';
export const PROFILE_BASE_REPORTS_PATH = `${PROFILE_BASE_PATH}/reports`;
export const PROFILE_BASE_PROJECTS_PATH = `${PROFILE_BASE_PATH}/projects`;
export const PROFILE_BASE_STARS_PATH = `${PROFILE_BASE_PATH}/stars`;
export const PROFILE_BASE_SETTINGS_PATH = `${PROFILE_BASE_PATH}/settings`;

// Legacy paths (for backwards compatibility, redirect to /profile/:entityName for personal entities)
export const PROFILE_REPORTS_PATH = `${PROFILE_PATH}/reports`;
export const PROFILE_PROJECTS_PATH = `${PROFILE_PATH}/projects`;
export const PROFILE_STARS_PATH = `${PROFILE_PATH}/stars`;

export const CREATE_TEAM_PATH = '/create-team';

export const TEAM_MEMBERS_PATH = `${PROFILE_PATH}/members`;
export const TEAM_SERVICE_ACCOUNTS_PATH = `${PROFILE_PATH}/service-accounts`;
export const TEAM_SETTINGS_PATH = `${PROFILE_PATH}/settings`;
